import React from "react"
import { HeadingTwo } from "buoy-core"
import BackLink from "../../common/components/BackLink"
import { Page, Content, BreadCrumbContainer } from "./Page"
import faqConfig from "./faqConfig"
import FAQSection from "./FAQSection"
import { INTERVIEW_LINK } from "../constants"

const FAQ = () => (
  <Page>
    <BreadCrumbContainer>
    <BackLink link={INTERVIEW_LINK} maintainState={true} />
    <Content>
      <HeadingTwo margin="20px 0 10px" alignLeft>
        {faqConfig.title}
      </HeadingTwo>
      {faqConfig.sections.map(section => <FAQSection {...section} />)}
    </Content>
    </BreadCrumbContainer>
  </Page>
)

export { FAQ as default }



// WEBPACK FOOTER //
// ./assets/payment/components/FAQ.js